import { Reveal, Eyebrow } from "./Reveal";
import { Mountain, Layers, Vault } from "lucide-react";

const PILLARS = [
  { icon: Mountain, title: "Direct Mine Offtake", text: "Supply contracted at source with producing mines — no intermediary dilution of custody or title." },
  { icon: Layers, title: "Non-Fractional Bullion", text: "Every bar is allocated, serialized, and independently assayed. Nothing pooled, nothing rehypothecated." },
  { icon: Vault, title: "Vault-to-Vault Settlement", text: "Metal moves between recognized vaults under documented chain-of-custody — never through the mail." },
];

export const About = () => (
  <section id="about" data-testid="about-section" className="relative py-28 lg:py-36 bg-[#0A0A0B] grain">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
      <Reveal>
        <div className="relative">
          <div className="absolute -inset-4 card-line pointer-events-none" />
          <img
            src="/assets/nugget-skm.webp"
            alt="Raw gold nugget stamped SKM-1926 on dark slate"
            className="w-full aspect-square object-cover"
            loading="lazy"
          />
          <div className="absolute bottom-5 left-5 bg-[#0A0A0B]/85 backdrop-blur px-5 py-3 card-line">
            <span className="font-mono2 text-[11px] tracking-[0.25em] text-[#C9A227] uppercase">Lot SKM-1926 · Assayed</span>
          </div>
        </div>
      </Reveal>

      <div>
        <Reveal>
          <Eyebrow>The Zorem Doctrine</Eyebrow>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-medium tracking-wide text-white leading-snug">
            Physical metal. <span className="gold-text">Proven counterparties.</span> Nothing else clears the desk.
          </h2>
          <p className="mt-6 text-base text-zinc-400 leading-relaxed">
            Zorem Commodities operates where the paper market ends. We originate,
            verify, and settle physical precious-metals transactions for
            institutions, family offices, and sovereign-adjacent buyers who
            require title they can audit — not exposure they must trust.
          </p>
        </Reveal>
        <div className="mt-12 space-y-8">
          {PILLARS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.1}>
              <div className="flex gap-5" data-testid={`pillar-${i}`}>
                <div className="shrink-0 w-11 h-11 flex items-center justify-center card-line bg-[#121215]">
                  <p.icon size={18} className="text-[#C9A227]" />
                </div>
                <div>
                  <h3 className="font-display text-lg text-[#E8C85A] tracking-wide">{p.title}</h3>
                  <p className="mt-1.5 text-sm text-zinc-400 leading-relaxed">{p.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <a href="/about" data-testid="home-about-story-link" className="inline-block mt-10 font-mono2 text-[11px] uppercase tracking-[0.25em] text-[#C9A227] hover:text-[#E8C85A] transition-colors">
          Read the full brand story →
        </a>
      </div>
    </div>
  </section>
);
